export const extractErrorMessage = (error: any): string => {
        const data = error?.response?.data;
        if (data?.non_field_errors) return data.non_field_errors[0];
        if (typeof data === "string") return data;
        return "Something went wrong. Please try again.";
};
